import api from "../api";

export const getEvents = (params) =>
  api.get("/event", { params });

export const getEventDetail = (id) =>
  api.get(`/event/${id}/detail`);
